import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../config/config";
import axiosInstance from "../../AxiosInstance";
import axios from "axios";
import { LiaHandPointDownSolid } from "react-icons/lia";
import { useAdminUser } from "../../context/AdminUserContext";
import { FaRegHandPointDown } from "react-icons/fa6";
import { ThreeDots } from "react-loader-spinner";
import Cookies from "js-cookie";

const Login = () => {
  const navigate = useNavigate();
  const { fetchAdminUserData, setAdminUser } = useAdminUser();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const baseURL = config.API_BASE_URL;

  const checkAndRedirectUser = (user) => {
    if (user && user.assignedRole) {
      let path = "";
      if (
        user.assignedRole === "User Admin" ||
        user.assignedRole === "Support Admin"
      ) {
        path = "/account/admin-dashboard";
      } else if (user.assignedRole === "Super Admin") {
        path = "/account/super-admin-dashboard";
      }

      if (path) {
        navigate(path);
      }
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setIsLoading(true);

    try {
      await axiosInstance.post("/v1/admin/auth/authenticate", {
        email,
        password,
      });

      try {
        const users = await fetchAdminUserData();
        const user = users[0];
        console.log("Logging in with user:", user);

        if (user && user.emailVerified) {
          if (
            user.assignedRole === "User Admin" ||
            user.assignedRole === "Support Admin" ||
            user.assignedRole === "Super Admin"
          ) {
            setAdminUser(user);
          }
          console.log("User data saved in context after login:", user);
          checkAndRedirectUser(user);
        } else {
          setErrorMessage(
            "Your email address is not verified. Please verify before logging in."
          );
        }
      } catch (userError) {
        console.error("Failed to fetch user details:", userError.message);
        setErrorMessage(
          "Failed to fetch user details. Please try again later."
        );
      }
    } catch (authError) {
      if (authError.response && authError.response.status === 401) {
        setErrorMessage("Invalid email or password");
      } else {
        console.error(
          "An error occurred during authentication:",
          authError.message
        );
        setErrorMessage("Authentication error. Please try again later.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleSignUpClick = () => {
    navigate("/admin/register");
  };

  return (
    <div className="login-wrapper">
      <div className="login-page-container">
        {isLoading && (
          <div className="loading-spinner">
            <ThreeDots
              visible={true}
              height="80"
              width="40"
              color="#4fa94d"
              radius="9"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        )}
        <div className="admnlogin-contents-container">
          <h1>LogIn - Administration</h1>
          <div className="login-error-message">{errorMessage}</div>
          <form onSubmit={handleLogin}>
            <div className="field-container">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="field-container">
              <label htmlFor="password">Password:</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit">Login</button>
            <div
              className="signup-prompt-link"
            >
              Forgot your password?
            </div>
            <div className="signup-prompt">
              <div>Don't have an account yet?</div>
              <FaRegHandPointDown className="signup-caret" />
              <div className="signup-prompt-button" onClick={handleSignUpClick}>
                Sign up here
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
